import { render, staticRenderFns } from "./BasicsEdit.vue?vue&type=template&id=772f644f&scoped=true&"
import script from "./BasicsEdit.vue?vue&type=script&lang=js&"
export * from "./BasicsEdit.vue?vue&type=script&lang=js&"
import style0 from "./BasicsEdit.vue?vue&type=style&index=0&id=772f644f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772f644f",
  null
  
)

export default component.exports